import React, { forwardRef } from "react";
import {
  Checkpoint,
  CheckpointRating,
  CheckpointType,
} from "../../lib/ground-aws-graphql-core/models/Api/Inspection";
import { getTranslation } from "../../utils/translation";
import classNames from "classnames";
import { ActionTypes } from "../../utils/types";
import { IntlShape } from "react-intl";
import ListCheckpointRatings from "./list-checkpoint-ratings";

interface Props {
  intl: IntlShape;
  item: CheckpointType;
  ratings: CheckpointRating[];
  items: {
    checkpointType: CheckpointType;
    checkpoint: Checkpoint;
    action: ActionTypes;
  }[];
}

const CheckpointTypeComponentRating = (props: Props, ref): JSX.Element => {
  const { item, items, ratings } = props;

  const classNameEnabled = () =>
    classNames(
      "absolute top-0 right-0 block h-2 w-2 rounded-full text-white shadow-solid",
      {
        "bg-red-400": !item.enabled,
        "bg-green-400": item.enabled,
      }
    );

  return (
    <div className="bg-white shadow overflow-hidden sm:rounded-lg mt-10">
      <div className="px-4 py-5 border-b border-gray-200 sm:px-6 flex justify-between">
        <div>
          <h3 className="text-16px leading-6 font-medium text-gray-900">
            <span className="inline-block relative">
              <span className="mr-3">{getTranslation(item.title)}</span>
              <span className={classNameEnabled()} />
            </span>
          </h3>
        </div>
      </div>
      <ListCheckpointRatings
        checkpointType={item}
        items={items}
        ratings={ratings}
      />
    </div>
  );
};

export default forwardRef(CheckpointTypeComponentRating);
